import axios from 'axios';
import Store from '../store';

const NONAUTH_ROUTES = ['/auth/login', '/contacts'];

axios.defaults.headers.common.Accept = 'application/json';

const ApiInstance = axios.create({
  baseURL: '/api/',
  timeout: 30000,
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
});

ApiInstance.interceptors.request.use((config) => {
  const { csrfToken } = localStorage;
  config.headers['x-csrf-token'] = csrfToken;
  Store.commit('increaseQuery');
  return config;
}, (error) => {
  Store.commit('decreaseQuery');
  // Store.commit('showSnackbar', error.toString());
  return Promise.reject(error);
});

ApiInstance.interceptors.response.use((response) => {
  Store.commit('decreaseQuery');
  return response;
}, (error) => {
  Store.commit('decreaseQuery');
  if (error.response.status === 401 && !NONAUTH_ROUTES.includes(window.location.pathname)) {
    window.location = `/auth/login?redirect=${window.location.pathname}`;
  }
  return Promise.reject(error);
});

export default ApiInstance;
